import { BaseModel } from "./base.model"
import { DeliveryMethodsModel } from "./delivery-methods.model"
import { PaymentMethodModel } from "./payment-method.model"


class FieldModel {
  is_enabled: boolean;
  is_required: boolean;

  constructor(obj: any = null) {
    this.is_enabled = obj?.is_enabled || false
    this.is_required = obj?.is_required || false
  }
}
class CheckoutFieldsModel {
  document: FieldModel
  phone: FieldModel
  email: FieldModel
  name: FieldModel
  last_name: FieldModel
  constructor(obj: any = null) {
    this.document = new FieldModel(obj?.document)
    this.phone = new FieldModel(obj?.phone)
    this.email = new FieldModel(obj?.email)
    this.name = new FieldModel(obj?.name)
    this.last_name = new FieldModel(obj?.last_name)
  }

}

export class SettingModel {
  has_cards: boolean
  has_covenants: boolean
  guest_flow: boolean
  has_qr: boolean
  has_queue: boolean
  has_wallet: boolean
  coupons: boolean
  tips: boolean
  products_with_comments: boolean
  delivery_methods: DeliveryMethodsModel
  payment_methods: PaymentMethodModel[]
  locations: BaseModel
  checkout_fields: CheckoutFieldsModel
  is_catalog: boolean
  upselling: boolean;
  hide_prices: boolean
  print_intent: boolean
  disable_controls_buttons_product: boolean;
  cash_back: CashBackModel

  constructor(obj: any = null) {
    this.has_cards = obj?.has_cards
    this.has_covenants = obj?.has_covenants
    this.guest_flow = obj?.guest_flow
    this.has_qr = obj?.has_qr
    this.has_queue = obj?.has_queue
    this.has_wallet = obj?.has_wallet
    this.coupons = obj?.coupons || false
    this.tips = obj?.tips || false
    this.products_with_comments = obj?.products_with_comments || false
    this.delivery_methods = new DeliveryMethodsModel(obj?.delivery_methods)
    this.payment_methods = Object.keys(obj?.payment_methods || {}).map(key => obj?.payment_methods[key])
    this.locations = new BaseModel(obj?.locations)
    this.checkout_fields = new CheckoutFieldsModel(obj?.checkout_fields)
    this.is_catalog = obj?.is_catalog || false
    this.upselling = obj?.upselling || false,
    this.hide_prices = obj?.hide_prices || false,
    this.print_intent = obj?.print_intent || false
    this.disable_controls_buttons_product = obj?.disable_controls_buttons_product || false;
    this.cash_back = new CashBackModel(obj?.cashback)
  }
}

class CashBackModel {
  is_enabled: boolean

  constructor(obj: any = null) {
    this.is_enabled = obj?.is_enabled || false
  }
}
